import { io } from "socket.io-client";
import { base_url } from "./constants"; 

export const socket = io(base_url, { autoConnect: false });